export type TrawlOptions<A = unknown, B = A, C = A> = {
  teamA: A[]
  teamB: B[]
  fight: (a: A, b: B, indexOf: { a: number; b: number }) => C | null
}

export const trawl = <A = unknown, B = A, C = A>(
  options: TrawlOptions<A, B, C>,
): C | null => {
  const { fight, teamA, teamB } = options
  let idxA = -1
  for (const a of teamA) {
    let idxB = -1
    ++idxA
    for (const b of teamB) {
      ++idxB
      const result = fight(a, b, { a: idxA, b: idxB })
      if (result !== null) {
        return result
      }
    }
  }

  return null
}
